import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '../style';

const OrgStructure = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <div className="org-structure">
                <header className="org-structure__header">
                    <h1 className="org-structure__title">{t('orgStructure.title')}</h1>
                    <p className="org-structure__description">
                        {t('orgStructure.description')}
                    </p>
                </header>

                <div className="section-divider">
                    <h2 className="section-divider__title">{t('orgStructure.sections.units')}</h2>
                </div>

                {/* Председатель правления */}
                <div className="department-staff">
                    <h3 className="department-staff__title">{t('orgStructure.sections.chairman.title')}</h3>
                    <ul className="staff-list">
                        <li className="staff-member">
                            <h4 className="staff-member__name">{t('orgStructure.sections.chairman.name')}</h4>
                            <p className="staff-member__position">{t('orgStructure.sections.chairman.position')}</p>
                            <p className="staff-member__contact">{t('orgStructure.sections.chairman.contact')}</p>
                        </li>
                    </ul>
                </div>

                {/* Бухгалтерия */}
                <div className="department-staff">
                    <h3 className="department-staff__title">{t('orgStructure.sections.accounting.title')}</h3>
                    <ul className="staff-list">
                        <li className="staff-member">
                            <h4 className="staff-member__name">{t('orgStructure.sections.accounting.name')}</h4>
                            <p className="staff-member__position">{t('orgStructure.sections.accounting.position')}</p>
                            <p className="staff-member__contact">{t('orgStructure.sections.accounting.contact')}</p>
                        </li>
                    </ul>
                </div>

                {/* Департамент анализа и развития банковской системы */}
                <div className="department-staff">
                    <h3 className="department-staff__title">{t('orgStructure.sections.bankingDept.title')}</h3>
                    <ul className="staff-list">
                        <li className="staff-member">
                            <h4 className="staff-member__name">{t('orgStructure.sections.bankingDept.name')}</h4>
                            <p className="staff-member__position">{t('orgStructure.sections.bankingDept.position')}</p>
                            <p className="staff-member__contact">{t('orgStructure.sections.bankingDept.contact')}</p>
                        </li>
                    </ul>
                </div>

                {/* Юридический отдел */}
                <div className="department-staff">
                    <h3 className="department-staff__title">{t('orgStructure.sections.legalDept.title')}</h3>
                    <ul className="staff-list">
                        <li className="staff-member">
                            <h4 className="staff-member__name">{t('orgStructure.sections.legalDept.name')}</h4>
                            <p className="staff-member__position">{t('orgStructure.sections.legalDept.position')}</p>
                            <p className="staff-member__contact">{t('orgStructure.sections.legalDept.contact')}</p>
                        </li>
                    </ul>
                </div>

                {/* Департамент ИТ */}
                <div className="department-staff">
                    <h3 className="department-staff__title">{t('orgStructure.sections.itDept.title')}</h3>
                    <ul className="staff-list">
                        <li className="staff-member">
                            <h4 className="staff-member__name">{t('orgStructure.sections.itDept.name')}</h4>
                            <p className="staff-member__position">{t('orgStructure.sections.itDept.position')}</p>
                            <p className="staff-member__contact">{t('orgStructure.sections.itDept.contact')}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </Container>
    );
};

export default OrgStructure;
